import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { NewsService } from "../../services/news.service";
import { environment } from '../../../environments/environment';
import { DeployTime } from 'src/environments/deploytime';
import { LogsService } from '../../services/logs.service';
import { reduce, take } from "rxjs/operators";
import {
  UntypedFormGroup,
  Validators,
  UntypedFormControl,
  FormControl,
  FormGroupDirective,
  NgForm,
} from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MiscService } from "src/app/services/misc.service";
import { config } from "./particles";
import { ActionsSubject, Store } from "@ngrx/store";
import {
  generateNextcloudState,
  genericError,
  nextcloudStateChanged,
  setDefaultPlatform,
  setNextcloudJwt,
} from "src/app/actions/news.actions";
import { ErrorStateMatcher } from "@angular/material/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, lastValueFrom } from "rxjs";
import { State } from "src/app/reducers";
import { ofType } from "@ngrx/effects";
import { HttpHeaders } from "@angular/common/http";
import { CookieService } from "src/app/services/cookie.service";
export class InputErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class LoginComponent implements OnInit {
  params: object = {};

  isLoginBtnDisabled: boolean = false;

  ncState: string = "";
  ncState$: Observable<string> = this.store.select(
    (state) => state.globalSettings.nextcloudState
  );

  jwtValid: Boolean = false;

  closeAfterLogin = false;

  state: string = "";
  code: string = "";

  constructor(
    private logService: LogsService,
    private miscService: MiscService,
    private authService: AuthService,
    private router: Router,
    private store: Store<State>,
    private activatedRoute: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private actions$: ActionsSubject,
    private cookieService: CookieService
  ) {
    const deployTime = DeployTime.getInstance(this.logService);
    this.ncState$.subscribe((state) => {
      this.ncState = state;
    });
  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.closeAfterLogin) {
        this.closeAfterLogin = true;
      }
      if (params.state) {
        this.state = params.state;
      }
      if (params.code) {
        this.code = params.code;
      }
    });
    this.checkURL();
  }

  async login() {
    this.spinnerService.show();
    this.isLoginBtnDisabled = true;
    const newState = this.genState(16);
    this.store.dispatch(generateNextcloudState({ value: newState }));
    this.cookieService.setCookie("state", newState);
    this.spinnerService.hide();
    this.authService.getNextcloudData().subscribe((response) => {
      window.location.href = `${response.nextcloudUrl}/apps/oauth2/authorize?response_type=code&client_id=${response.clientId}&scope=login&state=${newState}`;
    });
  }

  checkURL() {
    if (this.state !== "" && this.code !== "") {
      this.loginProcess();
    } else {
      this.checkJWT();
    }
  }

  loginProcess() {
    if (this.jwtValid === false) {
      this.spinnerService.show();
      // Subscribe to the route parameters
      this.activatedRoute.queryParams.subscribe(async (params) => {
        // Access the parameters using the 'params' object
        const state = params.state;
        const code = params.code;

        //If state is invalid, redirect to login screen
        if (state !== this.cookieService.getCookie("state")) {
          this.spinnerService.hide();
          this.store.dispatch(
            genericError({
              error:
                "Error when trying to login with nextcloud. Please try again.",
            })
          );
          this.router.navigate(["/login"]);
          return;
        }
        await this.authService.authenticate(code);
        this.spinnerService.hide();
      });
    }
  }

  checkJWT() {
    //Check if JWT is stored
    let jwt = this.cookieService.getCookie("jwt");
    //JWT is stored
    if (jwt !== undefined && jwt !== null) {
      this.authService.checkJwt().subscribe(
        (response: any) => {
          if (response.message === "Token is valid!") {
            this.jwtValid = true;
            this.cookieService.deleteCookie("state");
            this.router.navigate(["/news"]);
          }
        },
        (error) => {
          // Handle error
          if (error.status == 401) {
            this.jwtValid = false;
          }
        }
      );
    } else {
      //JWT is not stored
      this.jwtValid = false;
    }
  }

  genState(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    return result;
  }
}